// extracted by mini-css-extract-plugin
module.exports = {"loader":"_4e5f713ae4--loader--_V4v2","content":"_4e5f713ae4--content--srZVk"};